module.exports = {"apiKey":"AIzaSyAotjybKy1DoEsi_p3MEKwV8L6cvefJk7M","authDomain":"golf-shop-35cb5.firebaseapp.com","databaseURL":"https://golf-shop-35cb5.firebaseio.com","projectId":"golf-shop-35cb5","storageBucket":"golf-shop-35cb5.appspot.com","messagingSenderId":"799599529643","appId":"1:799599529643:web:c19cbc58ad2a178b7ff1ee"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase/config.json
// module id = KyJT
// module chunks = 12